import {getInjection} from '@runlab/di'
import {Product} from '@/src/core/domain/entities/product'
import parse, {HTMLReactParserOptions} from 'html-react-parser'
import React from 'react'
import {ProductListItem} from '@/src/features/catalog/product-list/product-list-item'
import {FavouriteBtn} from '@/src/features/catalog/add-to-favourite'
import {Routes} from '@/src/config/routes'

import {ProductListItemProvider} from '@/src/features/catalog/product-list/product-list-item.provider'
import {ExternalType, parseExternalLink} from '@/src/shared/utils/links'

export const parseHTMLContent = async (html: string) => {
  let products: Product[] = []

  const productIds: Id[] = []

  const matches = html.matchAll(/\{[^}]*?product\D*(\d+)[^}]*?\}/gim)

  for (const match of matches) {
    productIds.push(match[1] as Id)
  }

  if (productIds.length > 0) {
    const responseData = await getInjection('IApiClientService').post<{items: Product[]}>(
      Routes.webApi.products.list,
      {
        data: {ids: productIds},
      },
    )

    products = responseData.items
  }

  const options: HTMLReactParserOptions = {
    replace: node => {
      // заменяем только текстовые узлы, содержащие {product:...}
      if (node.type === 'text' && typeof node.data === 'string') {
        const parts: React.ReactNode[] = []
        const re = /\{[^}]*?product\D*(\d+)[^}]*?\}/gim

        let last = 0
        let m: RegExpExecArray | null

        while ((m = re.exec(node.data)) !== null) {
          const id = Number(m[1])
          if (m.index > last) parts.push(node.data.slice(last, m.index))

          const product = products.find(p => p.id.toString() === id.toString())

          if (!product) return <></>

          const productVM = getInjection('ProductListItemViewModelFactory')(product)

          parts.push(
            <ProductListItemProvider product={product}>
              <ProductListItem
                productListItemVM={productVM}
                key={productVM.key}
                badges={<FavouriteBtn productId={productVM.product.id} />}
                actionsMobile={<FavouriteBtn productId={productVM.product.id} />}
              />
            </ProductListItemProvider>,
          )

          last = m.index + m[0].length
        }

        if (last === 0) return // нет плейсхолдеров — оставить как есть
        if (last < node.data.length) parts.push(node.data.slice(last))
        return <>{parts}</>
      } else if (node.type === 'tag' && node.name == 'img') {
        node.attribs['src'] = parseExternalLink(ExternalType.Image, node.attribs['src'])
      }

      return node
    },
  }

  return {products, html: parse(html, options), htmlText: html}
}
